<ion-menu [disabled]="disabled" [side]="side" [swipeGesture]="swipeGesture" contentId="app-content" menuId="featureMenu">
    <ng-content></ng-content>
</ion-menu>
